import React from 'react';
import CreateTemplateDraft from '../../../template-list/create-template-draft/components/formWithButtons';
import R from 'ramda';
import { ListItem, FlatButton } from 'material-ui';

export default ({
  contractRequest,
  isSingleLoc,
  router,
  foundMatchedTemplate,
  foundMatchedDrafts,
}) => {
  if (!foundMatchedTemplate) {
    if (foundMatchedDrafts && foundMatchedDrafts.length) {
      return (
        <div style={{ border: '1px solid #e0e0e0', margin: '0 32px 32px', padding: '8px 16px' }}>
          We have found below unfinished drafts for this contracting period:
          {
            foundMatchedDrafts.map((draft, ix) => {
              return (
                <ListItem
                  key={ix}
                  disabled
                  primaryText={draft.templateName}
                  secondaryText={!isSingleLoc && draft.locationName}
                  rightAvatar={<FlatButton secondary label="Continue Loading Rates" onTouchTap={() => router.push(`/contracting/draft/${draft.originalContractId}/details`)}/>}
                />
              );
            })
          }
        </div>
      );
    }
    return (<div style={{ border: '1px solid #e0e0e0', margin: '0 32px 32px', padding: '8px 16px' }}>
      <CreateTemplateDraft
        prefillData={{
          startDate: contractRequest.startDate,
          endDate: contractRequest.endDate,
          buyerName: contractRequest.buyerName,
        }}
      />
    </div>);
  }
};



// WEBPACK FOOTER //
// ./src/app/components/contracting/supplier-wizard/respond-contract-request/right-side/rightSideContent.jsx